import { action, makeObservable, observable } from "mobx";

import { Invoice } from "models/Invoice/Invoice";
import moment from "moment";
import invoice from "../api/controllers/Invoice";
import AppStore from "./AppStore";

class Store {
    @observable public invoice?: Invoice;
    @observable public activeMonth?: Date;

    constructor() {
        makeObservable(this);
    }

    @action public resetStore = () => {
        this.invoice = undefined;
        this.activeMonth = undefined;
    };

    @action public setInvoice = (newInvoice: Invoice) => {
        this.invoice = newInvoice;
    };

    @action public getInvoice = async () => {
        if (!this.activeMonth) {
            const invoiceData = await invoice.getData();

            if (invoiceData) {
                this.setActiveMonth(moment(invoiceData.month).toDate());
                this.invoice = invoiceData;
            }
        } else {
            this.getInvoiceForActiveMonth();
        }
    };

    @action public getInvoiceForActiveMonth = async () => {
        const params = this.parseMonthAndYear();
        this.invoice = undefined;
        this.invoice = await invoice.getData(params);
    };

    @action public generateInvoiceForActiveMonth = async () => {
        const params = this.parseMonthAndYear();

        AppStore.showFader();

        const invoiceData = await invoice.generateInvoice(params);

        AppStore.hideFader();

        this.invoice = invoiceData;
    };

    @action
    public uploadKsefNumberForActiveMonth = async (ksefNumber: string) => {
        const params = this.parseMonthAndYear();

        AppStore.showFader();

        try {
            const invoiceData = await invoice.uploadKsefNumber(params, ksefNumber);

            if (invoiceData) {
                this.invoice = invoiceData;
            }
        } catch (error) {
            AppStore.setIsErrorModalVisible(true);
            AppStore.setErrorModalMessage(error.message);
        } finally {
            AppStore.hideFader();
        }
    };

    @action public setActiveMonth = (month: Date) => {
        this.activeMonth = month;
    };

    private parseMonthAndYear = () => {
        const month = moment(this.activeMonth);

        return `${month.format("YYYY")}-${String(month.format("M")).padStart(2, "0")}`;
    };
}

const InvoiceStore = new Store();

export default InvoiceStore;
